import { closeBracketsKeymap } from '@codemirror/autocomplete';
import { defaultKeymap, history, undo, redo } from '@codemirror/commands';
import { EditorState, type Extension } from '@codemirror/state';
import { drawSelection, EditorView, keymap } from '@codemirror/view';

import { overrideKeys } from '../editor-state-configs/editor-config.js';

export const FilterFieldInteractionsExtension: (args: {
  closeSuggestions: () => void;
  // oxlint-disable-next-line typescript/no-explicit-any
  showBoundary: (error: any) => void;
}) => Extension = ({ closeSuggestions, showBoundary }) => [
  // Enable line wrapping so that overflowing text is wrapped into the next line.
  EditorView.lineWrapping,
  // Handling internal exceptions
  EditorView.exceptionSink.of((err) => showBoundary(err)),
  // Enable multiple selections (CMD / ctrl + drag).
  EditorState.allowMultipleSelections.of(true),
  // Provides a undo/redo history
  history(),

  drawSelection(),
  keymap.of([
    ...defaultKeymap.filter(({ key }) => !overrideKeys.includes(key ?? '')),
    ...closeBracketsKeymap,
    {
      key: 'Escape',
      run: () => {
        closeSuggestions();
        return false;
      },
    },
    {
      key: 'Mod-z',
      run: undo,
    },
    {
      key: 'Mod-y',
      run: redo,
    },
    {
      key: 'Mod-Shift-z',
      run: redo,
    },
  ]),

  // Prevent pasting multi-line content into the single-line filter field.
  // Newline sequences are collapsed into a single space so word boundaries
  // are preserved (e.g. "foo\nbar" → "foo bar"), then the result is trimmed.
  EditorView.domEventHandlers({
    paste(event: ClipboardEvent, view: EditorView) {
      const text = event.clipboardData?.getData('text/plain');
      if (text === null || text === undefined || !/[\r\n]/.test(text)) {
        return false;
      }
      event.preventDefault();
      const sanitized = text.replace(/[\r\n]+/g, ' ').trim();
      view.dispatch(view.state.replaceSelection(sanitized), {
        userEvent: 'input.paste',
      });
      return true;
    },
  }),
];
